import { get } from 'lodash';

/**
 * Returns whether the given vehicle is a truck.
 *
 * NOTE: since there is no obvious/simple way to determine whether a vehicle is a truck, we check if the vehicle model
 * has a submodel that contains the word "cab".
 *
 * @param vehicle
 * @returns {boolean}
 */
export const isTruckVehicle = vehicle =>
  Object.keys(get(vehicle, 'model.submodels', {})).some(vehicleSubmodel => /(^|-)cab($|-)/.test(vehicleSubmodel));
